import { render, staticRenderFns } from "./vehicleinspections.html?vue&type=template&id=31792d24&scoped=true&external"
import script from "./vehicleinspections.vue?vue&type=script&lang=js"
export * from "./vehicleinspections.vue?vue&type=script&lang=js"
import style0 from "./vehicleinspections.vue?vue&type=style&index=0&id=31792d24&prod&scoped=true&lang=css"
import style1 from "./vehicleinspections.vue?vue&type=style&index=1&id=31792d24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31792d24",
  null
  
)

export default component.exports